export const getOrigin = () => {
  return window.location.href.replace(window.location.pathname, '');
};

export const getCalendarDownloadRoute = (initials: string, token: string) => {
  return `${getOrigin()}/api/schedule/partner/${initials}/iCal?token=${token}`;
};
